import { FC } from "react";
import { t } from "i18next";
import moment from "moment";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

import Loader from "@components/shared/Loader/Loader";
import { DateFormats } from "@enums/shared.enum";
import { BookingParticipantModalProps } from "@models/components/booking.model";
import { applyLocalization } from "@services/common.service";

const BookingParticipantModal: FC<BookingParticipantModalProps> = ({
  isLoading,
  participant,
  participantModal,
  setParticipant,
  toggleParticipantModal,
}) => {
  return (
    <Modal
      isOpen={participantModal}
      onClosed={() => setParticipant(null)}
      toggle={toggleParticipantModal}
      className="fg-dev-participants-modal"
    >
      <div className="modal-header">
        <div>
          <h5>{t("Calendar.participants")}</h5>
          <div className="d-flex">
            {participant?.startTime &&
              moment(participant?.startTime).format(DateFormats.LT)}{" "}
            {participant?.endTime && " - "}
            {participant?.endTime &&
              moment(participant?.endTime).format(DateFormats.LT)}{" "}
            {participant?.resource?.title && " . "}
            {participant?.resource?.title &&
              applyLocalization(participant?.resource?.title)}
          </div>
        </div>
        <button
          type="button"
          className="btn-close"
          onClick={toggleParticipantModal}
          aria-label="Close"
        ></button>
      </div>

      <ModalBody>
        <Loader isLoading={isLoading} />

        {participant?.organizer && participant?.organizer?.length > 0 && (
          <>
            <h5>{t("Calendar.organizer")}</h5>
            <div>
              {participant?.organizer.map(organizer => (
                <div
                  key={organizer.id}
                  className="d-flex align-items-center fg-participants-profile"
                >
                  <div className="d-flex justify-content-center align-items-center rounded-circle text-white text-center fg-profile-pic">
                    {organizer.name.charAt(0).toUpperCase()}
                  </div>
                  <span className="ms-2">{organizer.name}</span>
                </div>
              ))}
            </div>
          </>
        )}
        {participant?.participants && participant?.participants?.length > 0 && (
          <>
            <h5 className="mt-4">{t("Calendar.participants")}</h5>
            <div>
              {participant?.participants.map(participant => (
                <div
                  key={participant.id}
                  className="d-flex align-items-center fg-participants-profile"
                >
                  <div className="d-flex justify-content-center align-items-center rounded-circle text-white text-center fg-profile-pic">
                    {participant.name.charAt(0).toUpperCase()}
                  </div>
                  <span className="ms-2">{participant.name}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleParticipantModal}>
          {t("Calendar.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BookingParticipantModal;
